// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Router from "next/router";
import * as NextRecaptchaV3 from "next-recaptcha-v3";
import * as MediaQuery$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/hooks/MediaQuery.mjs";
import * as UtmHelper$PorterinFeature from "../../core/helpers/UtmHelper.mjs";
import * as AuthBinding$PorterinFeature from "../../core/helpers/AuthBinding.mjs";
import * as CityContext$PorterinFeature from "../../../contexts/city-context/CityContext.mjs";
import * as LocaleHelpers$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/helpers/LocaleHelpers.mjs";
import * as CountryHelpers$PorterinUtils from "../../../../../../node_modules/@porterin/utils/src/helpers/CountryHelpers.mjs";
import * as AuthContextV1$PorterinFeature from "../../../containers/login/view-model/contexts/auth-context/AuthContextV1.mjs";
import * as LeadFlowBindings$PorterinFeature from "../../../containers/bindings/LeadFlowBindings.mjs";
import * as RecaptchaContext$PorterinFeature from "../../../contexts/recpatcha-context/RecaptchaContext.mjs";
import * as CommonVehicleHelper$PorterinFeature from "../../core/helpers/CommonVehicleHelper.mjs";
import * as VehicleFareEstimateFormModuleScss from "./styles/VehicleFareEstimateForm.module.scss";
import * as VehicleFareEstimateFormState$PorterinFeature from "./component/form/VehicleFareEstimateFormState.mjs";
import * as VehicleFareEstimateInputModuleScss from "./styles/VehicleFareEstimateInput.module.scss";
import * as VehicleFareEstimateFormFieldsCmp$PorterinFeature from "./component/form/VehicleFareEstimateFormFieldsCmp.mjs";
import * as VehicleFareEstimateFormInterface$PorterinFeature from "./component/form/VehicleFareEstimateFormInterface.mjs";

var default_form_styles = VehicleFareEstimateFormModuleScss;

var default_input_styles = VehicleFareEstimateInputModuleScss;

function VehicleFareEstimateFormCmp(Props) {
  var has_round_cornersOpt = Props.has_round_corners;
  var service_category = Props.service_category;
  var stylesOpt = Props.styles;
  var input_field_stylesOpt = Props.input_field_styles;
  var fare_estimate_vm = Props.fare_estimate_vm;
  var source = Props.source;
  var on_lead_success_handler = Props.on_lead_success_handler;
  var has_round_corners = has_round_cornersOpt !== undefined ? has_round_cornersOpt : false;
  var styles = stylesOpt !== undefined ? Caml_option.valFromOption(stylesOpt) : default_form_styles;
  var input_field_styles = input_field_stylesOpt !== undefined ? Caml_option.valFromOption(input_field_stylesOpt) : default_input_styles;
  Router.useRouter();
  var match = Router.useRouter();
  var locale = match.locale;
  var asPath = match.asPath;
  var recaptcha_execute = NextRecaptchaV3.useReCaptcha();
  var recaptcha_context = RecaptchaContext$PorterinFeature.useRecaptchaContext(undefined);
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var isDesktop = MediaQuery$PorterinUtils.useMediaQuery("(min-width: 560px)");
  var match$1 = React.useState(function () {
        return VehicleFareEstimateFormState$PorterinFeature.initialFormState(undefined);
      });
  var setPreviousInput = match$1[1];
  var match$2 = React.useState(function () {
        
      });
  var setResponse = match$2[1];
  var form = VehicleFareEstimateFormInterface$PorterinFeature.Form.useForm(match$1[0], {
        error_msgs: fare_estimate_vm.errors_msgs,
        country: CountryHelpers$PorterinUtils.countryCodeFromLocale(locale)
      }, (function (output, callbacks) {
          var match = UtmHelper$PorterinFeature.getUtmStringFromPath(asPath);
          VehicleFareEstimateFormState$PorterinFeature.onFormSubmit(output, callbacks, service_category, citySelectedContext.category, recaptcha_execute, setResponse, source, isDesktop, citySelectedContext.city_selected, recaptcha_context, match[0], match[1], locale, citySelectedContext.city_selected);
        }));
  React.useEffect((function () {
          var match = form.status;
          var exit = 0;
          if (typeof match === "number") {
            if (match !== /* Editing */0) {
              exit = 1;
            }
            
          } else if (match.TAG !== /* Submitting */0) {
            exit = 1;
          }
          if (exit === 1) {
            Curry._1(setPreviousInput, (function (param) {
                    return form.input;
                  }));
            Curry._1(form.reset, undefined);
          }
          
        }), [form.status]);
  return React.createElement("div", {
              className: has_round_corners ? "" + styles["rounded-corners"] + " " + styles["vehicle-fare-estimate-container"] + "" : styles["vehicle-fare-estimate-container"]
            }, LocaleHelpers$PorterinUtils.isBkfEnabled(locale, isDesktop) ? (
                isDesktop ? React.createElement(LeadFlowBindings$PorterinFeature.FareEstimateForm.make, {
                        category: CommonVehicleHelper$PorterinFeature.fromCategoryStringToBinding(service_category),
                        city_context: citySelectedContext,
                        auth_data: AuthBinding$PorterinFeature.convertAuthContext(AuthContextV1$PorterinFeature.useAuthContext(undefined)),
                        on_lead_success_handler: on_lead_success_handler
                      }) : React.createElement(LeadFlowBindings$PorterinFeature.FareEstimateMobileForm.make, {
                        category: CommonVehicleHelper$PorterinFeature.fromCategoryStringToBinding(service_category),
                        city_context: citySelectedContext,
                        auth_data: AuthBinding$PorterinFeature.convertAuthContext(AuthContextV1$PorterinFeature.useAuthContext(undefined)),
                        on_lead_success_handler: on_lead_success_handler
                      })
              ) : React.createElement(React.Fragment, undefined, React.createElement("h2", {
                        className: styles["modal-title"]
                      }, fare_estimate_vm.vehcile_modal_content.title), React.createElement(VehicleFareEstimateFormFieldsCmp$PorterinFeature.make, {
                        styles: styles,
                        input_field_styles: input_field_styles,
                        form: form,
                        fare_estimate_vm: fare_estimate_vm,
                        response: match$2[0],
                        service_category: service_category,
                        citySelectedContext: citySelectedContext
                      })));
}

var make = VehicleFareEstimateFormCmp;

export {
  default_form_styles ,
  default_input_styles ,
  make ,
}
/* default_form_styles Not a pure module */
